<script>
    export let params;
</script>


<h2 class="font-bold text-3xl mb-4">{params.item}</h2>

<p>A student based in Ireland who is highly interested in technology, science, programming, robotics, graphic design, photography, aerodynamics and more! I've made this website to serve as a collection of my work.</p>